<template>
    <div id="nav-bar" class="main-nav clearfix">
        <div class="container">
            <div class="row">
                <nav class="navbar navbar-expand-lg col">
                    <div class="site-nav-inner float-left">
                        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="true" aria-label="Toggle navigation">
                            <i class="fas fa-bars"></i>
                        </button>
                        <!-- End of Navbar toggler -->

                        <div id="navbarSupportedContent" class="collapse navbar-collapse navbar-responsive-collapse">
                            <ul class="nav navbar-nav">
                                <li v-for="item in menu_items" v-bind:data="item" v-bind:key="item.id" class="nav-item" :class="{ 'active' : item.is_selected, 'dropdown': item.children }">
                                    <a :href="'/'+item.path" class="nav-link" data-toggle="dropdown" v-if="item.children">{{item.name}}
                                        <i class="fa fa-angle-down"></i>
                                    </a>
                                    <a :href="'/'+item.path" class="nav-link" v-else>{{item.name}}</a>
                                    <ul class="dropdown-menu" role="menu" v-if="item.children">
                                        <li v-for="childItem in item.children" v-bind:data="childItem" v-bind:key="childItem.id">
                                            <a :href="'/'+childItem.path">{{childItem.name}}</a>
                                        </li>
                                    </ul>
                                </li>
                            </ul><!--/ Nav ul end -->
                        </div><!--/ Collapse end -->

                    </div><!-- Site Navbar inner end -->
                </nav><!--/ Navigation end -->

                <div class="nav-search">
                    <span id="search" data-toggle="collapse" data-target="#search-block" aria-expanded="false" aria-controls="#search-block">
                        <i class="fa fa-search"></i>
                    </span>
                    <div class="collapse search-block" id="search-block">
                        <form v-on:submit.prevent="search">
                            <input type="text" class="form-control" placeholder="Keresés" v-model="q">
                            <span class="search-close" data-toggle="collapse" data-target="#search-block">×</span>
                        </form>
                    </div><!-- Site search end -->
                </div><!-- Search end -->

            </div><!--/ Row end -->
        </div><!--/ Container end -->

    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'NavBar',
        props: ['data'],
        data() {
            return {
                menu_items: this.getMenuItems,
                q: '',
            }
        },
        methods: {
            showSearch() {
                $('#nav-bar .search-block').show();
            },
            hideSearch() {
                $('#nav-bar .search-block').show();
            },
            search() {
                if(this.$route.name === 'search') {
                    this.$store.dispatch('search', {
                        'q': this.q,
                    });
                } else {
                    this.$router.push({
                        path: '/kereses/' + this.q,
                        params: {
                            'q': this.q
                        }
                    })
                }

                this.hideSearch();
            },
        },
        mounted() {

        },
        computed: {
            ...mapGetters([
                'getMenuItems',
            ])
        },
        watch: {
            getMenuItems: function(newVal) {
                this.menu_items = newVal;
            },
        }
    }
</script>

<style lang="scss">

    @import '~@/absctracts/variables.scss';

    .main-nav>.container>.row {
        border-top: 3px solid $red;
        border-bottom: 1px solid #dedede;
        margin-left: 0;
        margin-right: 0;
    }

    .navbar {
        border-radius: 0;
        border: 0;
        margin-bottom: 0;
        padding: 0px;
    }

    .navbar-nav {
        height: 49px;
    }

    .navbar-nav>li.mega-dropdown, .site-nav-inner {
        position: static;
    }

    .site-nav-inner {
        position: relative;
    }

    .navbar-nav>li {
        padding: 0px 5px 5px 5px;
        position: relative;
    }

    .navbar-nav>li.mega-dropdown {
        position: static;
    }

    .navbar-nav .dropdown-menu {
        position: static;
        float: none;
    }

    ul.navbar-nav>li:hover>a:before, ul.navbar-nav>li.active>a:before {
        border-color: $red;
        opacity: 1;
        transform: scale(1) translateZ(0);
    }

    ul.navbar-nav>li>a:before {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        opacity: 0;
        border-bottom: 3px solid;
        transform: scale(0) translateZ(0);
        -webkit-transition: -webkit-transform 0.45s ease, opacity 0.55s ease;
        -moz-transition: -moz-transform 0.45s ease, opacity 0.55s ease;
        -ms-transition: -ms-transform 0.45s ease, opacity 0.55s ease;
        -o-transition: -o-transform 0.45s ease, opacity 0.55s ease;
        transition: transform 0.45s ease, opacity 0.55s ease;
    }

    ul.navbar-nav>li>a {
        display: inline-block;
        padding: 0 15px;
        line-height: 50px;
        font-size: 14px;
        font-weight: 700;
        text-transform: uppercase;
        color: $dark-grey;
        margin: 0;
        position: relative;
        -webkit-transition: 350ms;
        -moz-transition: 350ms;
        -o-transition: 350ms;
        transition: 350ms;
    }

    .navbar-nav>li>.dropdown-menu {
        border-top: 1px solid #dedede;
    }

    .dropdown-menu {
        background: $white;
        border-radius: 0;
        border: 0;
        border: 0;
        box-shadow: 0px 3px 3px 2px rgba(0,0,0,0.15);
        padding: 10px;
        margin-top: 0;
        min-width: 230px;
        text-align: left;
        z-index: 100;

        li a {
            border-bottom: 1px solid #e5e5e5;
            color: #333333;
            display: block;
            font-size: 14px;
            font-weight: 400;
            line-height: normal;
            text-decoration: none;
            padding: 12px 15px 12px 10px;
        }

        li a:hover {
            background-color: $red;
            color: $white;
        }
    }

    @media (max-width: 576px) {
        .dropdown-menu.show {
            display: block;
            position: absolute;
            top: 51px;
        }

        .navbar-nav>li {
            padding: 0px 20px 5px 5px;
            position: relative;
        }
    }

    .dropdown-menu.show {
        display: block;
    }

    .nav-search {
        float: right;
        display: inline-block;
        position: relative;
        cursor: pointer;
        top: 12px;
        right: 10px;

        .search {
            padding: 10px;
        }
    }

    @media screen and (max-width: 768px) {
        .nav-search {
            float: right;
            display: inline-block;
            position: relative;
            cursor: pointer;
            top: 5px;
            right: 10px;

            .search {
                padding: 10px;
            }
        }

        .search-block .search-close {
            right: 4px !important;
            top: -29px !important;
        }
    }

    .search-block {
        background-color: $white;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
        margin-top: 0;
        padding: 10px;
        position: absolute;
        right: -10px;
        top: 79%;
        width: 300px;
        z-index: 10;
    }

    .search-block .form-control {
        background-color: #f7f7f7;
        border: none;
        color: #000;
        width: 100%;
        height: 40px;
        padding: 0 12px;
    }

    .search-block .search-close {
        background: $white;
        color: #525252;
        cursor: pointer;
        font-size: 32px;
        padding: 5px;
        position: absolute;
        right: 4px;
        top: -43px;
    }

    .form-control {
        background: none;
        border-radius: 0;
        border: 1px solid #dadada;
        box-shadow: none;
        color: #959595;
        font-size: 12px;
        height: 40px;
        padding: 5px 20px;
    }


</style>